import { useTranslation } from '@lyearn/i18n';
import LearnerActionModal from '@/modules/learner/components/LearnerActionModal';

import { LearnerReactivateModalProps } from './types';

const LearnerReactivateModal: React.FC<LearnerReactivateModalProps> = (props) => {
  const { learner, onClose, onSubmit } = props;

  const { t } = useTranslation();

  return (
    <LearnerActionModal
      action={{
        label: t('Common:Actions.Reactivate'),
        onClick: onSubmit,
      }}
      header={{
        title: t('Admin:LearnerAndGroups.ReactivateAccount'),
        description: t('Admin:LearnerAndGroups.ReactivateAccountDescription'),
      }}
      learner={learner}
      onClose={onClose}
    />
  );
};

export default LearnerReactivateModal;
